import moment from "moment";

export class DateFormat {
  static dateRendering = (
    dateVal: Array<Record<string, unknown>>,
    key: "from" | "to"
  ) => {
    switch (key) {
      case "from":
        return moment(dateVal![0]?.$d).startOf("day").format("YYYY-MM-DD");
      case "to":
        return moment(dateVal![1]?.$d).format("YYYY-MM-DD");
    }
  };

  static getDateRange = (dateRange: number = 0) => {
    return {
      fromDate: moment()
        .subtract(dateRange, "day")
        .startOf("day")
        .format("YYYY-MM-DD"),
      toDate: moment().format("YYYY-MM-DD"),
    };
  };

  static convertToISO = (dateStr: { $y: number; $M: number; $D: number }) => {
    const year = dateStr.$y;
    const month = dateStr.$M + 1;
    const day = dateStr.$D;
    const isoDate = `${year.toString().padStart(4, "0")}-${month
      .toString()
      .padStart(2, "0")}-${day.toString().padStart(2, "0")}T00:00:00.000Z`;
    return isoDate;
  };
}

export const { convertToISO, dateRendering, getDateRange } = DateFormat;
